import { Badge, FlexRow, LinkButton, MainMenuAvatar, Panel } from '@epam/promo';
import { MainMenuCustomElement } from '@epam/uui-components';
import { USER_ROLE, UserRole } from 'models/user.model';
import { useToast, useTaskSwitcher, useAdminLogout } from 'hooks';
import { UserProfileProps } from './UserProfile.model';
import css from './UserProfile.module.scss';

export const UserProfile = ({ avatar, role }: UserProfileProps) => {
  const toast = useToast();
  const switchTask = useTaskSwitcher();
  const { mutate: logout } = useAdminLogout();

  const logoutCurrentUser = () =>
    switchTask({
      onSuccess: () => {
        toast.warning(
          `Checking unsaved changes... 
					You will be redirected in 3 seconds`,
        );

        setTimeout(logout, 3000);
      },
      onAbort: logout,
    });

  return (
    <MainMenuCustomElement estimatedWidth={210} priority={10}>
      <FlexRow spacing="12">
        <LinkButton
          caption="Log out"
          cx={css.badge__btn}
          size="36"
          onClick={logoutCurrentUser}
        />
        <Panel cx={css.badge}>
          <MainMenuAvatar avatarUrl={avatar} cx={css.badge__avatar} />
          <Badge
            caption={USER_ROLE[role as UserRole]}
            captionCX={css.badge__caption}
            color="blue"
            cx={css.badge__role}
            fill="solid"
          />
        </Panel>
      </FlexRow>
    </MainMenuCustomElement>
  );
};
